/**
 * Gets attribute value as a number
 * @param {HTMLElement} element
 * @param {string} attribute
 * @param {number} defaultValue
 * @return {number}
 */
function getNumberAttribute(element, attribute, defaultValue) {
  let value = parseFloat(element.getAttribute(attribute));

  if (Number.isNaN(value)) {
    value = defaultValue;
  }

  return value;
}

/**
 * Gets selected DOM element's text as value/array
 * @param {HTMLElement} element root node from which to collect data
 * @param {string} tag selected DOM element
 * @param {boolean} [isMultiple] If `true` array is returned with all collected values
 * @return {string|string[]} value of the `tag`.
 */
function getValue(element, tag, isMultiple) {
  const selected = Array.from(element.querySelectorAll(tag));
  if (isMultiple) {
    const value = [];

    selected.forEach((s) => {
      value.push(s.textContent);
    });

    return value;
  }

  let value = '';

  selected.forEach((s) => {
    value = s.textContent;
  });

  return value;
}

function get(url, cb) {
  return jQuery.get(url, cb);
}

function getIframeHeight(event) {
  if (event.origin === 'https://fixedincome.twentyfouram.com' && typeof event.data === 'number') {
    document.getElementById('pardotIframe').setAttribute('style', `height:${event.data}px`);
  }
}

function toggleTransparentHeader() {
  jQuery(document).on('scroll', () => {
    if (jQuery('.app-header__content').offset().top < 10) {
      jQuery('.app-header').addClass('transparent');
    } else {
      jQuery('.app-header').removeClass('transparent');
    }
  });
}

function makeFieldRequired(fieldToListen, fieldToChange) {
  const fieldsValues = [];
  jQuery.each(jQuery(fieldToListen).toArray(), (i, input) => {
    fieldsValues.push({
      id: input.id,
      value: input.value,
    });
  });
  jQuery(fieldToListen).on('input', (e) => {
    const triggeredInput = jQuery(e.currentTarget);
    const triggersParent = triggeredInput.parent();
    const errorMessage = `<span class="messages messages--warning messages--required">${Drupal.t('Current password is now required')}</span>`;
    const triggerFieldsValue = triggeredInput.val();
    const inputsPrevVal = fieldsValues.find((el) => el.id === triggeredInput[0].id).value;

    if (triggerFieldsValue == inputsPrevVal) {
      triggersParent.find('.messages').remove();
      jQuery(fieldToChange).removeClass('form-required js-form-required');
    } else {
      if (triggersParent.find('.messages').length == 0) {
        triggersParent.prepend(errorMessage);
        jQuery(fieldToChange).addClass('form-required js-form-required');
      }
    }
  });
}

function scrollToTopAccordion() {
  const acc = jQuery('.collapse-block');

  acc.on('shown.bs.collapse', (e) => {
    const collapseHeader = jQuery('[data-bs-target="#' + e.target.id + '"]');

    if (!isInViewport(collapseHeader)) {
      const headerHeight = jQuery('.app-header').height();
      const top = collapseHeader.offset().top - headerHeight - 20;
      jQuery('html,body').animate(
        {
          scrollTop: top,
        },
        'fast',
      );
    }
  });
}

function isInViewport(el = null) {
  if (el) {
    var elementTop = el.offset().top;
    var elementBottom = elementTop + el.outerHeight();

    var viewportTop = jQuery(window).scrollTop();
    var viewportBottom = viewportTop + jQuery(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  return true;
}

function removeDialogButtonFocus() {
  jQuery.ui.dialog.prototype._focusTabbable = function () {};
}

function removeSubscribeButton() {
  const utagCookie = getCookie('utag_main');
  const btnSubscribe = jQuery('.social__item--subscribe');

  if (btnSubscribe.length) {
    if (typeof utagCookie !== 'undefined' && utagCookie.includes('_amh')) {
      btnSubscribe.remove();
    } else {
      btnSubscribe.removeClass('d-none');
    }
  }
}

function giveTokenCookieValue() {
  const utagCookie = getCookie('utag_main');
  const amhValue = utagCookie ? utagCookie.match(/(?:)(?<=_amh:).*?(?=%)/) : null;
  const replacement = amhValue ? amhValue : '';
  const links = document.querySelectorAll('a');

  links.forEach((value) => {
    let href = value.getAttribute('href');

    if (href && href.includes('{vti-value}')) {
      href = href.replace('{vti-value}', replacement);
      value.setAttribute('href', href);
    }
  });
}

function getCookie(cname) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${cname}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function hideKeyFactHeaderForEmpty() {
  const cells = document.querySelectorAll('#key-facts .table.highlighted td');

  cells.forEach((cell) => {
    const cellData = cell.innerText;
    if (cellData === '-' || !cellData.length > 0) {
      cell.classList.add('cell-empty');
    }
  });
}

export {
  get,
  getIframeHeight,
  getNumberAttribute,
  getValue,
  giveTokenCookieValue,
  hideKeyFactHeaderForEmpty,
  makeFieldRequired,
  removeDialogButtonFocus,
  removeSubscribeButton,
  scrollToTopAccordion,
  toggleTransparentHeader,
};
